import Axios from "axios/index";
import { getToken } from "./tokenManager";
import { deleteCookie } from "./cookie";
import { ACCESS_TOKEN } from "../constants/storageKeys";
import { appVersion } from "../constants";
import {
  getProjectRelatedLocalStorage,
  removeProjectRelatedLocalStorage
} from "../assets/projectLocalStorage";
import logout from "../assets/logout";

const Request = config => {
  const needToken = config.needToken;
  // const userId = localStorage.getItem("user_id");
  // const projectId = localStorage.getItem("project_id");
  // const cookiePanel = getCookie(
  //     `fav-panel-${userId}-${projectId}`
  // );
  // const inPettyCashierRoutes = window.location.pathname.startsWith(DASHBOARD_PETTY_CASHIER);
  // const inManagerRoutes = window.location.pathname.startsWith(DASHBOARD_MANAGER);
  // if (userId && projectId && !((inPettyCashierRoutes && cookiePanel === PETTY_CASHIER_PANEL) || (
  //     inManagerRoutes && cookiePanel === MANAGER_PANEL
  // ))){
  //   const cookie = inPettyCashierRoutes ? PETTY_CASHIER_PANEL: inManagerRoutes? MANAGER_PANEL:cookiePanel
  //   setCookie(
  //       `fav-panel-${userId}-${projectId}`,
  //       cookie,
  //       "max"
  //   );
  // }
  const redirectLogin = () => {
    if (typeof window !== "undefined") {
      let href = window.location.href;
      href = href.replace("/login" + window.location.search, "");
      if (window.location.origin !== href) {
        const redirectUrl = encodeURIComponent(
          window.location.pathname + window.location.search
        );
        window.location.replace("/?redirect=" + redirectUrl);
      }
    }
  };
  const removeTokens = () => {
    deleteCookie(ACCESS_TOKEN);
    redirectLogin();
  };
  // let refreshing = false;
  // let queue = [];
  Axios.interceptors.request.use(
    async function(config) {
      if (config.method === "get") {
        config.params = config.params
          ? { ...config.params, app_version: appVersion }
          : { app_version: appVersion };
      } else {
        if (config.headers["Content-Type"] === "multipart/forms-data") {
          if (
            config.data instanceof FormData &&
            (!config.data.get || !config.data.get("app_version"))
          ) {
            config.data.append("app_version", appVersion);
          }
        } else {
          config.data = config.data
            ? { ...config.data, app_version: appVersion }
            : { app_version: appVersion };
        }
      }
      if (needToken && getToken(ACCESS_TOKEN)) {
        Object.assign(config.headers, {
          Authorization: "Bearer " + getToken(ACCESS_TOKEN)
        });
      } else if (needToken && !getToken(ACCESS_TOKEN)) {
        removeTokens();
      }
      return config;
    },
    function(error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // const processQueue = (error, token = null) => {
  //   queue.forEach(prom => {
  //     if (error) {
  //       prom.reject(error);
  //     } else {
  //       prom.resolve(token);
  //     }
  //   });
  //   queue = [];
  // };

  Axios.interceptors.response.use(
    function(response) {
      // sessionStorage.removeItem("error-500");
      return response;
    },
    function(error) {
      if (error.response) {
        const errorRes = error.response;
        if (errorRes.status === 401) {
          // token expired
          removeTokens();
        } else if (errorRes.status === 404) {
          // not found
          if (error.response.data.project_not_found) {
            // project not found
            if (getProjectRelatedLocalStorage()) {
              removeProjectRelatedLocalStorage();
              window.location.reload();
            }
          }
        } else if (errorRes.status === 403) {
          if (errorRes.data.user_not_verified) {
            logout();
          } else if (
            errorRes.data.project_status_expired ||
            errorRes.data.user_limit_exceeded
          ) {
            removeProjectRelatedLocalStorage();
            window.location.reload();
          }
        }
      }
      return Promise.reject(error);
      // const originalRequest = error.config;
      // if (!error.response) {
      //   store.dispatch(InitAction.changeServerInterruptStatus(REQUEST_TIMEOUT));
      // } else if (
      //   error.response.status >= 500 &&
      //   !(
      //     error.response &&
      //     error.response.data &&
      //     error.response.data.message &&
      //     Array.isArray(error.response.data.message) &&
      //     error.response.data.message.length > 0
      //   )
      // ) {
      //   store.dispatch(InitAction.changeServerInterruptStatus(RESPONSE_500));
      // } else if (
      //   error.response.status === 401
      //   // && originalRequest.url === process.env.REACT_APP_API_URL + "/oauth/token"
      // ) {
      //   removeTokens();
      // } else if (error.response.status === 404) {
      //   if (error.response.data.project_not_found) {
      //     if (
      //       localStorage.getItem("project_id") &&
      //       localStorage.getItem("project_info")
      //     ) {
      //       localStorage.removeItem("project_id");
      //       localStorage.removeItem("project_info");
      //       window.location.reload();
      //     }
      //   }
      // }
      // else if (error.response.status === 401 && !originalRequest._refreshTry) {
      //   if (refreshing) {
      //     return new Promise(function(resolve, reject) {
      //       queue.push({ resolve, reject });
      //     })
      //       .then(token => {
      //         originalRequest.headers["Authorization"] = "Bearer " + token;
      //         return Axios(originalRequest);
      //       })
      //       .catch(err => {
      //         return Promise.reject(err);
      //       });
      //   }
      //   originalRequest._refreshTry = true;
      //   if (!getToken("refreshToken")) {
      //     removeTokens();
      //     return Promise.reject(error);
      //   }
      //   refreshing = true;
      //   return new Promise(function(resolve, reject) {
      //     Axios({
      //       method: "post",
      //       url: process.env.REACT_APP_API_URL + "/oauth/token",
      //       data: {
      //         grant_type: "refresh_token",
      //         refresh_token: getToken("refreshToken"),
      //         client_id: process.env.REACT_APP_CLIENT_ID,
      //         client_secret: process.env.REACT_APP_CLIENT_SECRET
      //       }
      //     })
      //       .then(async response => {
      //         await setToken(response.data);
      //         Axios.defaults.headers.common["Authorization"] =
      //           "Bearer " + getToken("accessToken");
      //         originalRequest.headers["Authorization"] =
      //           "Bearer " + getToken("accessToken");
      //         processQueue(null, getToken("accessToken"));
      //         resolve(Axios(originalRequest));
      //       })
      //       .catch(err => {
      //         processQueue(err, null);
      //         reject(err);
      //       })
      //       .then(() => {
      //         refreshing = false;
      //       });
      //   });
      // }
      // return Promise.reject(error);
    }
  );
  return Axios.request(config);
};
export default Request;
